// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--gTkmR","tag":"_93444fe79c--tag--y_HtV"};